import _ from "lodash";

const INITIAL_STATE = {
  data: { Paginacao: [], Resultado: [] },
  notificacao: null,
  isFetching: false,
  isProcessando: false,
  forceUpdate: 0
};

export const getHistoricoImportacaoRequest = "GET_HISTORICO_IMPORTACAO_REQUEST";
export const getHistoricoImportacaoSuccess = "GET_HISTORICO_IMPORTACAO_SUCCESS";
export const getHistoricoImportacaoFailure = "GET_HISTORICO_IMPORTACAO_FAILURE";

export const getNotificacaoImportacaoRequest =
  "GET_NOTIFICACAO_IMPORTACAO_REQUEST";
export const getNotificacaoImportacaoSuccess =
  "GET_NOTIFICACAO_IMPORTACAO_SUCCESS";
export const getNotificacaoImportacaoFailure =
  "GET_NOTIFICACAO_IMPORTACAO_FAILURE";

export const clearNotificacaoImportacaoSuccess = "CLEAR_NOTIFICACAO_IMPORTACAO";

export const onImportacaoSuccess = "ON_IMPORTACAO_SUCCESS";
export const onImportacaoRequest = "ON_IMPORTACAO_REQUEST";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case getHistoricoImportacaoRequest:
      return { ...state, isFetching: true };
    case getHistoricoImportacaoSuccess:
      return {
        ...state,
        data: { ...action.payload },
        isFetching: false,
        isProcessando: action.payload?.Resultado.reduce((acc, curr) => acc || curr.Status === 4, false)
      };
    case getHistoricoImportacaoFailure:
      return {
        ...state,
        isFetching: false,
      };

    case getNotificacaoImportacaoRequest:
      return { ...state, isFetching: true };
    case getNotificacaoImportacaoSuccess:
      return {
        ...state,
        notificacao: { 
          ...state.notificacao,
          ...action.payload 
        },
        isFetching: false,
      };
    case getNotificacaoImportacaoFailure:
      return {
        ...state,
        isFetching: false,
      };

    case clearNotificacaoImportacaoSuccess:
      return {
        ...state,
        notificacao: null,
        isFetching: false,
      };

    case onImportacaoRequest:
      return {
        ...state,
      };
      
    case onImportacaoSuccess:
      let mustForceUpdate = false;
      let importacao = { ...action.payload };
      importacao = _.mapKeys(importacao, (v, k) => {
        return k.charAt(0).toUpperCase() + k.slice(1);
      });
      let novoResultado = [...state.data.Resultado];
      const index = novoResultado.findIndex((item) => item.Id === importacao.Id);

      if (index >= 0) {
        novoResultado[index] = importacao;
      } else {
        novoResultado.unshift(importacao);
        if (novoResultado.length > 10) novoResultado.splice(-1, 1);
      }

      mustForceUpdate = (importacao.Status === 5);

      return {
        ...state,
        data: { ...state.data, Resultado: novoResultado },
        isProcessando: novoResultado?.reduce((acc, curr) => acc || curr.Status === 4, false),
        forceUpdate: mustForceUpdate ? state.forceUpdate + 1 : state.forceUpdate
      };

    default:
      return state;
  }
};
